// extracted by mini-css-extract-plugin
export default {"iframe":"AppViewer_iframe__IPLBS"};